export const CLASS_CUSTOM_PROPERTY = 'custom-property';
export const CLASS_CUSTOM_PROPERTY_ITEM = CLASS_CUSTOM_PROPERTY + '__item';
